<template>
  <div v-if="p.documents && p.documents.length || displayed_documents_flux && displayed_documents_flux.length"
    class="is-border-left is-border-right">
    <div class="columns is-vcentered is-border-bottom has-bg-light">
      <div class="column is-size-6 is-padding-top-small is-padding-bottom-small">
        <span class="has-text-weight-medium">{{ (p.documents.length || 0) + (displayed_documents_flux.length || 0) }} document(s)</span>
      </div>
       <a target="_blank" :href="documentsSelected[0].file.path" :download="documentsSelected[0].file.filename"
        v-if="documentSelected && documentsSelected.length === 1"
        class="has-text-white is-uppercase is-size-5 has-text-weight-medium column is-narrow has-bg-success is-padding-top-small is-padding-bottom-small">
        <span class="icon is-padding-right-xsmall"><i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i></span>
        <span>Télécharger document</span>
      </a>
      <div @click="downloadDocuments()" class="column is-narrow has-bg-success is-padding-top-small is-padding-bottom-small" style="cursor: pointer;" v-else-if="documentSelected && documentsSelected.length > 1">
        <a class="has-text-white is-uppercase is-size-5 has-text-weight-medium">
            <span class="icon is-padding-right-xsmall"><i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i></span>
            <span>Télécharger documents</span>
          </a>
      </div>
    </div>
    <table class="table is-hoverable is-fullwidth is-first-fixed-xsmall is-last-fixed-small is-marginless-bottom is-border-bottom">
      <tbody class="is-size-5 has-text-text">
        <template v-for="(d, i) in p.documents">
          <documents-list-row :key="'document-'+i" :id="'document-'+i" :source="d" :emailSent="isSent" @selectedItem="selectedItem"></documents-list-row>
        </template>
        <template v-for="(d, i) in displayed_documents_flux">
          <documents-list-row :key="'documentflux-'+i" :id="'documentflux-'+i" :source="d" :emailSent="isSent" @selectedItem="selectedItem"></documents-list-row>
        </template>
      </tbody>
    </table>
  </div>
  <div v-else class="column">
    <em><b>Aucun document.</b></em>
  </div>
</template>

<script>
  import { DownloadFile } from '@/mixins'
  import DocumentsListRow from './DocumentsListRow'

  export default {
    name: 'ProgramDocumentsList',
    mixins: [DownloadFile],
    components: {
      DocumentsListRow
    },
    data () {
      return {
        loading: false
      }
    },
    props: {
      program: {
        type: Object,
        required: true
      }
    },
    computed: {
      p () {
        return this.program
      },
      displayed_documents_flux () {
        if (this.program.documents_flux && this.program.documents_flux.length > 0) {
          return this.program.documents_flux.filter(document => document.display)
        } else return []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/Tabs/ProgramDocumentsList.vue